"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformanceInsightImpactLevel = exports.PerformanceInsightPhase = exports.FunnelStage = void 0;
var FunnelStage;
(function (FunnelStage) {
    FunnelStage["FULL_FUNNEL"] = "Full Funnel";
    FunnelStage["PRE_CLICK"] = "Ad Creative";
    FunnelStage["POST_CLICK"] = "Storefront";
})(FunnelStage || (exports.FunnelStage = FunnelStage = {}));
var PerformanceInsightPhase;
(function (PerformanceInsightPhase) {
    PerformanceInsightPhase["PRE_CLICK"] = "Ad Creative";
    PerformanceInsightPhase["POST_CLICK"] = "Storefront";
})(PerformanceInsightPhase || (exports.PerformanceInsightPhase = PerformanceInsightPhase = {}));
var PerformanceInsightImpactLevel;
(function (PerformanceInsightImpactLevel) {
    PerformanceInsightImpactLevel["HIGH_IMPACT"] = "HIGH IMPACT";
    PerformanceInsightImpactLevel["MEDIUM_IMPACT"] = "MEDIUM IMPACT";
    PerformanceInsightImpactLevel["LOW_IMPACT"] = "LOW IMPACT";
})(PerformanceInsightImpactLevel || (exports.PerformanceInsightImpactLevel = PerformanceInsightImpactLevel = {}));
